module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"paymentPlanButton":"Lataa maksusuunnitelma (pdf)","paymentPlanConfirmation":"Maksusuunnitelmavahvistus"},"se":{"paymentPlanButton":"Ladda betalningsplan info (pdf)","paymentPlanConfirmation":"Betalningsplansbekräftelse"},"en":{"paymentPlanButton":"Download payment plan information (pdf)","paymentPlanConfirmation":"Paymentplanconfirmation"}}')
  delete Component.options._Ctor
}
